export default "/_next/static/node_modules/@riot-private/blades-ui/dist/skins/2xko/assets/carousel-left.svg";